/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  LogMetadataTransformer,
  LogMetadataTransformerInterface,
} from "../LogMetadataTransformer";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "taker",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "TransformerMetadata",
    type: "event",
  },
  {
    inputs: [],
    name: "deployer",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address payable",
        name: "ethRecipient",
        type: "address",
      },
    ],
    name: "die",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address payable",
            name: "sender",
            type: "address",
          },
          {
            internalType: "address payable",
            name: "recipient",
            type: "address",
          },
          {
            internalType: "bytes",
            name: "data",
            type: "bytes",
          },
        ],
        internalType: "struct IERC20Transformer.TransformContext",
        name: "context",
        type: "tuple",
      },
    ],
    name: "transform",
    outputs: [
      {
        internalType: "bytes4",
        name: "success",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class LogMetadataTransformer__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<LogMetadataTransformer> {
    return super.deploy(overrides || {}) as Promise<LogMetadataTransformer>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): LogMetadataTransformer {
    return super.attach(address) as LogMetadataTransformer;
  }
  connect(signer: Signer): LogMetadataTransformer__factory {
    return super.connect(signer) as LogMetadataTransformer__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): LogMetadataTransformerInterface {
    return new utils.Interface(_abi) as LogMetadataTransformerInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): LogMetadataTransformer {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as LogMetadataTransformer;
  }
}
